import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import FacilityPopup from "./FacilityPopup"
import db from './db';
import HubPopup from "./HubPopup";

// FacilityTable component
export default class FacilityTable extends React.Component {

    messagesEnd=undefined;

    // constructor
    constructor(props) {
        super(props);

        // initalize state
        this.state = {
            facilities:undefined,
            facility:Object.assign({}, FacilityPopup.emptyFacility),
            facilityPopupVisible:false,
            facilityTabIndex:0,
            hub:Object.assign({}, HubPopup.emptyHub),
            hubPopupVisible:false,
            addFacility:false,
            initFacilityId:this.props.initFacilityId,
            initCompanyId:this.props.initCompanyId
        }
        this.inputRef = React.createRef();
    }
 

    componentDidMount() {
        this.inputRef.current.focus();
        if(this.state.initFacilityId || this.state.initCompanyId){
            setTimeout(function() { //Start the timer
                this.queryFacilities();  // wait to query facility
            }.bind(this), 2000)            
        }        
    }
    inputFilterKeyUp(event) {
        if (event.keyCode === 13) {
          event.preventDefault();
          this.queryFacilities();
        }
    }

    // render
    render() {
        //if (!this.state.facilities){
            // get list of all facilities
            //this.queryFacilities();           
        //}

        return (
            <div>
                Search:<input id="search_column" className='input-filter' onKeyUp={this.inputFilterKeyUp.bind(this)} ref={this.inputRef} />&nbsp;
                facility id:<input id="facility_id" className='input-filter' defaultValue={this.state.initFacilityId} onKeyUp={this.inputFilterKeyUp.bind(this)} />&nbsp;                    
                company id:<input id="company_id" className='input-filter' defaultValue={this.state.initCompanyId} onKeyUp={this.inputFilterKeyUp.bind(this)} />&nbsp;                    
                <button onClick={()=>{this.queryFacilities()}} >Query Facility</button> &nbsp;                
                <button onClick={()=>{this.addFacility()}} >Add Facility</button>
                <TableScrollbar height="80vh">
                    <ErrorBoundary>
                        <Table columns={[
                                    { key: 'id', title:"ID", width :10 } 
                                    , { key: 'display_name', title:"Facility Name", width :15 }
                                    , { key: 'source', title:"Source", width :15 }                                    
                                    , { key: 'display_organization_name', title:"Parent Company", width :15 }
                                    , { key: 'display_address', title:"Facility Address", width :20 }
                                    , { key: 'display_city', title:"city", width :20 }
                                    , { key: 'display_state', title:"state", width :20 }
                                    , { key: 'display_zip', title:"zip", width :20 }
                                    , { key: 'facility_type', title:"Type", width :10 }
                                    , { key: 'wix_order_number', title:"WIX #", width :10 }
                                ]} 
                                dataSource={this.state.facilities} 
                                onRowClick={this.editFacility.bind(this)} 
                                />
                    </ErrorBoundary>
                    <div style={{ float:"left", clear: "both" }}
                        ref={(el) => { this.messagesEnd = el; }}>
                            <br /><br />
                    </div>
                </TableScrollbar>
                <FacilityPopup 
                    facilityId={this.state.facility.id}
                    hubspot_company_id={this.state.facility.hubspot_company_id}
                    visible={this.state.facilityPopupVisible}
                    securityObject={this.props.securityObject}
                    onCloseFacilityPopup={this.closeFacilityPopup.bind(this)}
                    tabIndex={this.state.facilityTabIndex}
                >
                </FacilityPopup>
                <HubPopup
                    hubId={this.state.hub.id}
                    visible={this.state.hubPopupVisible}
                    securityObject={this.props.securityObject}
                    onCloseHubPopup={this.closeFacilityPopup.bind(this)}
                >
                </HubPopup>                
            </div>
        );
    }

    // load the table
    queryFacilities(params){
        db.getFacilities( 
            document.getElementById("search_column").value
            , undefined
            ,document.getElementById("facility_id").value
            ,document.getElementById("company_id").value
            ,this.props.securityObject
            ,(facilityList) => { 
                if(Array.isArray(facilityList)){
                    this.setState({
                        facilities : facilityList
                    });
                    if( (this.state.initFacilityId || this.state.initCompanyId) && facilityList.length>0){
                        this.editFacility(facilityList[0],0);
                        this.setState(
                            { initFacilityId : undefined
                                ,initCompanyId : undefined
                            }
                        );
                    }  
                }              
            }
            ,params
        )
    }

    // render the hubs that apear on the side of the facilities table
    renderHubs(cellData, rowData, rowIndex){
        let array=[];
        let arrayHubs=[];
        let hiddenClassName="";
        
        if(rowData.hubs.length>3){
            hiddenClassName="hidden";
            let btnPlus=React.createElement(
                'button'
                ,{  onClick: () => 
                    {   
                        this.setState({
                            facilityTabIndex:2
                        });           
                    }
                    ,key:"buttonPlus"+rowData.id
                }
                ,"+");
            array.push(btnPlus);
        }

        rowData.hubs.forEach(rowDataHub=>{
            let hubKey="buttonHub"+rowDataHub.id;
            let btn=React.createElement(
                'button'
                ,{  onClick: (event) => 
                    {
                        event.preventDefault();
                        this.editHub(rowDataHub, 0);
                    }
                    ,key:hubKey
                }
                ,rowDataHub.id+"-"+rowDataHub.hostname+" "+rowDataHub.name);
            arrayHubs.push(btn);

            let br=React.createElement( 'br',
                            {
                                key:"newLineHub"+rowDataHub.id
                            } );
            arrayHubs.push(br);
        });
        

        let divHubs=React.createElement(
            'div'
            ,{
                className:hiddenClassName
                , id:"hubList-"+rowData.id
                , key:"divChild"
            }
            ,arrayHubs);
        array.push(divHubs);        
        
        let div=React.createElement('div',{}, array );
        return div;    
    }

    // add a facility
    addFacility(){
        this.setState({
            facility:Object.assign({}, FacilityPopup.emptyFacility),
            facilityPopupVisible:true,
            addFacility:true
        });
    }
    // edit a facility
    editFacility( rowData, rowIndex ){
        this.setState({
            facility:rowData,
            facilityPopupVisible:true,
            addFacility:false
        });
    }

    // close the facility popup
    closeFacilityPopup(){
        this.queryFacilities(); 
        this.setState({
            hubPopupVisible:false,
            facilityPopupVisible:false,
            facilityTabIndex:0
        });
        if(this.state.addFacility){
            this.scrollToBottom()            
        }        
    }
   
     // edit a hub
     editHub( rowData, rowIndex ){
        this.setState({
            hub:rowData
            , hubPopupVisible:true
        })
    }

    // scroll to bottom
    scrollToBottom(){
        this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    }          

}